<template>
    <div :class="['modal-overlay', { 'is-visible': isVisible }]">
      <div class="modal-content">
        
  
        <div class="post-it-form post-it">
            <button class="close-button" @click="closeModal">&times;</button>
            <h2>Agregar Anotación</h2>
            <h6>
              Corte # {{ anotacion.corte_tienda_obj.numero }} en {{ tienda }}
            </h6>
            <form @submit.prevent="">
            <div class="form-group">
              <label for="observacion">Observación:</label>
              <textarea id="observacion" v-model="anotacion.observacion" rows="5" required></textarea>
            </div>
  
            <button class="save" @click="saveAnotacion()" type="submit">Guardar Anotación</button>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import DynamicService from "@/services/commons/DynamicService";
  export default {
    props: {
      // La prop 'isVisible' controlará si el modal se muestra o no.
      isVisible: {
        type: Boolean,
        default: false,
      },
      corteTienda:{
        type: Object,
        required: true
      },
      totalVenta:{
        type: Number,
        required: true
      },
      totalDetalles:{
        type: Number,
        required: true
      }

    },
    data(){
      return {
        anotacion: {
          observacion: '',
          corte_tienda_obj: null,
          corte_tienda: null,
          total_venta: 0.00,
          total_detalles: 0.00
        }
      }
    },
    watch: {
      // Cuando 'corteTienda' cambie, actualiza 'anotacion.corte_tienda'
      corteTienda: {
        immediate: true, // Ejecuta el watcher inmediatamente cuando se crea el componente
        handler(newValue) {
          this.anotacion.corte_tienda_obj = newValue;
          this.anotacion.corte_tienda = newValue.id;
        }
      },
      // Cuando 'totalVenta' cambie, actualiza 'anotacion.total_ventas'
      totalVenta: {
        immediate: true,
        handler(newValue) {
          this.anotacion.total_venta = newValue;
        }
      },
      // Cuando 'totalDetalles' cambie, actualiza 'anotacion.total_detalles'
      totalDetalles: {
        immediate: true,
        handler(newValue) {
          this.anotacion.total_detalles = newValue;
        }
      }
    },
    computed:{
      tienda(){
        return `${this.anotacion.corte_tienda_obj.tienda_obj.codigo}-${this.anotacion.corte_tienda_obj.tienda_obj.nombre}`
      }
    },
    methods: {
      // Método para guardar la anotación
      saveAnotacion() {
        let self = this;
        DynamicService.save("cxc","corte-tienda-anotaciones",self.anotacion)
        .then((response)=>{
          console.log(response.data);
          let respuesta = response.data;
          this.$toast.success(`Se creó con éxito la anotación ${respuesta.numero}`,"Guardar Anotación", {
            position: 'topRight'
          });
          self.closeModal();
        })
      },
      // Este método emite un evento 'close' para que el componente padre cierre el modal.
      closeModal() {
        this.$emit('close');
        this.anotacion.observacion = '';
      },
      // Maneja el clic en el fondo oscuro para cerrar el modal
      handleOverlayClick(event) {
        // Asegúrate de que el clic fue directamente en el overlay y no en el contenido del modal
        // 'modal-overlay' debe ser la clase del elemento sobre el que se hace clic
        if (event.target.classList.contains('modal-overlay')) {
          this.closeModal();
        }
      },
    },
    mounted() {
      // Añade el event listener al overlay cuando el componente es montado
      // Lo buscamos directamente con el selector de clase
      const modalOverlay = this.$el.querySelector('.modal-overlay');
      if (modalOverlay) {
        modalOverlay.addEventListener('click', this.handleOverlayClick);
      }
    },
    beforeUnmount() {
      // Elimina el event listener antes de que el componente sea destruido
      const modalOverlay = this.$el.querySelector('.modal-overlay');
      if (modalOverlay) {
        modalOverlay.removeEventListener('click', this.handleOverlayClick);
      }
    },
  };
  </script>
  
  <style scoped>
  /* Estilos del formulario dentro del post-it */
  .post-it-form {
    max-width: 600px;
    padding: 25px;
    box-sizing: border-box;
    position: relative;
    z-index: 1001;
  }
  
  h2 {
    text-align: center;
    color: #333;
    margin-bottom: 25px;
    font-size: 1.8em;
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 10px;
  }
  
  .form-group {
    margin-bottom: 18px;
  }
  
  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #555;
    font-size: 0.95em;
  }
  
  input[type='text'],
  input[type='number'],
  textarea,
  select {
    width: 100%;
    padding: 12px;
    border: 1px solid #ced4da;
    border-radius: 6px;
    box-sizing: border-box;
    font-size: 1em;
    transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  }
  
  input[type='text']:focus,
  input[type='number']:focus,
  textarea:focus,
  select:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    outline: none;
  }
  
  .disabled-input {
    background-color: #e9ecef;
    cursor: not-allowed;
  }
  
  textarea {
    resize: vertical;
    min-height: 100px;
  }
  
  button[type="submit"] {
    width: 100%;
    padding: 12px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 1.1em;
    font-weight: bold;
    transition: background-color 0.3s ease, transform 0.1s ease;
    margin-top: 20px;
  }
  
  button[type="submit"]:hover {
    background-color: #0056b3;
    transform: translateY(-1px);
  }
  
  button[type="submit"]:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
  
  .message {
    padding: 10px;
    border-radius: 5px;
    margin-top: 15px;
    text-align: center;
    font-weight: bold;
  }
  
  .success-message {
    color: #28a745;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
  }
  
  .error-message {
    color: #dc3545;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
  }
  
  /* --- Estilos para el efecto Post-it --- */
  .post-it {
    background-color: #ffe08a;
    border: 1px solid #e0c87f;
    border-radius: 2px;
    transform: rotate(-2deg);
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  }
  
  .post-it:hover {
    transform: rotate(0deg) scale(1.01);
    box-shadow: 8px 8px 20px rgba(0, 0, 0, 0.3);
  }
  
  .post-it h2,
  .post-it label {
    color: #4a4a4a;
  }
  
  .post-it input[type='text'],
  .post-it input[type='number'],
  .post-it textarea,
  .post-it select {
    background-color: rgba(255, 255, 255, 0.8);
    border-color: rgba(0, 0, 0, 0.1);
  }
  
  .post-it input[type='text']:focus,
  .post-it input[type='number']:focus,
  .post-it textarea:focus,
  .post-it select:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.15rem rgba(0, 123, 255, 0.2);
  }
  
  .post-it .disabled-input {
    background-color: rgba(233, 236, 239, 0.6);
  }
  
  .post-it .save {
    background-color: #6c757d;
    color: white;
  }
  
  .post-it .save:hover {
    background-color: #5a6268;
  }
  
  /* --- Estilos del Modal (con animación) --- */
  .modal-overlay {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    justify-content: center;
    align-items: center;
    z-index: 1000;

    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease-out, visibility 0.3s ease-out;
  }
  
  .modal-overlay.is-visible {
    opacity: 1;
    visibility: visible;
  }
  
  .modal-content {
    background-color: transparent;
    padding: 20px;
    border-radius: 8px;
    position: relative;
  
    transform: scale(0.8) rotate(-5deg);
    opacity: 0;
    transition: transform 0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55),
                opacity 0.3s ease-out;
  }
  
  .modal-overlay.is-visible .modal-content {
    transform: scale(1) rotate(-2deg);
    opacity: 1;
  }
  
  .close-button {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 24px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    z-index: 1002;
    transition: color 0.2s ease-in-out;
  }
  .close-button:hover {
    color: #dc3545;
  }
  </style>